import React from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";

const MultiSelectDropdown = ({
  errors,
  control,
  setValue,
  field,
  //   name,
  placeholder,
  rules,
  watch,
}) => {
  //   const selectedValues = watch(name);
  const { options, multi, name } = field;

  //   const selectedOptions = options.filter(option =>
  //     selectedValues?.includes(option.value)
  //   );

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          isMulti={multi}
          //   value={selectedOptions}
          placeholder={placeholder}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          //   onChange={(selectedOptions) => {
          //     const value = selectedOptions ? selectedOptions.map(option => option.value) : [];
          //     field.onChange(value);
          //     setValue(name, value);
          //   }}
          className={`react-select-container ${
            errors[name] ? "is-invalid" : ""
          }`}
        />
      )}
    />
  );
};

export default MultiSelectDropdown;
